import _ from "underscore";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import labels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import cartConfig from "emun.cart/cart.config";
import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";
import CartItem from "emun.cart/cart-item.model";
import resolve from "ioc/resolve";
import OrderTotalsPrompt from "emun.order/order-totals-prompt";
import modals from "webmodals/modals";

export default class CartListAdvanced {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.labels = labels;
		$ctrl.cartConfig = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.query = new AutoQuery({
			url: cartConfig.cartListAdvancedQuery || "QueryCartItems.json",
			criteria: {
				CartId: $ctrl.$cart.id,
			},
			orderBy: "ShipOn,Position",
			autoLoad: true,
			filters: cartConfig.cartListAdvancedFilters,
			pageSize: 1000,
			//onLoaded: (args) => $ctrl.unSelectAll(),
			scrub: ({ data }) => {
				data.results = data.results.map(
					(p) =>
						new CartItem({
							...p,
						})
				);
				$ctrl.clearAll();
				$ctrl.shipDates = _.groupBy(data.results, "shipOn");
				$ctrl.uniqueShipDates = Object.keys($ctrl.shipDates);
				$ctrl.uniqueShipDates.sort();

				$ctrl.uniqueShipDates.map((s) => {
					$ctrl.shipDates[s].total = 0;
					$ctrl.shipDates[s].tabOpen = true;
					//console.debug("s", s, $ctrl.shipDates[s].tabOpen);
					$ctrl.shipDates[s].forEach(function (obj) {
						$ctrl.shipDates[s].total += obj.extendedTotal;
					});
				});

				$ctrl.categories = _.groupBy(data.results, "category");
				$ctrl.uniqueCategories = Object.keys($ctrl.categories);
				$ctrl.uniqueCategories.sort();

				$ctrl.uniqueCategories.map((s) => {
					$ctrl.categories[s].total = 0;
					$ctrl.categories[s].tabOpen = true;
					//console.debug("s", s, $ctrl.shipDates[s].tabOpen);
					$ctrl.categories[s].forEach(function (obj) {
						$ctrl.categories[s].total += obj.extendedTotal;
					});
				});

				$ctrl.vendors = _.groupBy(data.results, "brandId");
				$ctrl.uniqueVendors = Object.keys($ctrl.vendors);
				$ctrl.uniqueVendors.sort();
				$ctrl.uniqueVendors.map((v) => {
					$ctrl.vendors.tabOpen = true;
					$ctrl.vendors[v].total = 0;
					$ctrl.vendors[v].tabOpen = true;
					//console.debug("s", s, $ctrl.shipDates[s].tabOpen);
					$ctrl.vendors[v].forEach(function (obj) {
						$ctrl.vendors[v].total += obj.extendedTotal;
					});

					var v_shipdates = _.groupBy($ctrl.vendors[v], "shipOn");
					$ctrl.vendors[v].shipdates = _.groupBy($ctrl.vendors[v], "shipOn");
					$ctrl.vendors[v].unique_shipdates = Object.keys(_.groupBy($ctrl.vendors[v], "shipOn"));
					$ctrl.vendors[v].unique_shipdates.map((s) => {
						$ctrl.vendors[v].shipdates[s].total = 0;
						$ctrl.vendors[v].shipdates[s].tabOpen = true;
						//console.debug("s", s, $ctrl.shipDates[s].tabOpen);
						$ctrl.vendors[v].shipdates[s].forEach(function (obj) {
							$ctrl.vendors[v].shipdates[s].total += obj.extendedTotal;
						});
					});
	
				});

				$ctrl.totalsQuery.load();
			},
		});
		$ctrl.totalsQuery = new AutoQuery({
			url: "QueryCartItemsJoin.json?Active=true&OrderTotalsGroupBy=true",
			criteria: {
				cartId: $ctrl.$cart.id,
				Sum: "extendedTotal",
				Count: "productId",
				groupBy: $ctrl.cartConfig.cartListAdvancedTotalsGrouping || "cartItemShipOn",
				orderBy: $ctrl.cartConfig.cartListAdvancedTotalsGrouping || "cartItemShipOn",
			},
			autoLoad: false,
			pageSize: 100,
			onLoaded: function (args) {
				if (args.total > 0) {
					console.debug("$ctrl.shipDates", $ctrl.shipDates);
					var runningTotal = 0;
					args.results.forEach(function (s) {
						if ($ctrl.shipDates[s.cartItemShipOn] != undefined) {
							$ctrl.shipDates[s.cartItemShipOn].total = s.sumextendedTotal;
							runningTotal += s.sumextendedTotal;
							s.runningTotal = runningTotal;
							$ctrl.shipDates[s.cartItemShipOn].runningTotal = runningTotal;
							s.percentOfTotal = 100 * (runningTotal / $ctrl.$cart.subTotal);
							$ctrl.shipDates[s.cartItemShipOn].percentOfTotal = s.percentOfTotal;
						}
						
					});
				}
				//console.info("$ctrl.totalsQuery", $ctrl.totalsQuery);
			}
		});
		$ctrl.positions = [];
		//const $rootScope = resolve("$rootScope");
		$ctrl.$on("cartItemOptionsChanged", (e, args) => {
			//$ctrl.query.load(true);
			args.request.positions.forEach((p) => {
				var item = $ctrl.query.results.filter((r) => r.position === p);
				if (item.length > 0) {
					item[0].shipOn = args.cartItem.shipOn;
					item[0].$shipOn = item[0].shipOn.format("MM/DD/YY");
					var components = $ctrl.query.results.filter(
						(r) => r.isKitComponent && r.parentPosition === p
					);
					components.forEach((obj) => {
						obj.shipOn = args.cartItem.shipOn;
						obj.$shipOn = item[0].shipOn.format("MM/DD/YY");
					});
				}
			});
			$ctrl.refreshShipDates();
		});
		$ctrl.$on("cartItemQuantityChanged", (e, args) => {
			//$ctrl.totalsQuery.load();
			$ctrl.refreshShipDates(true);
		});
		$ctrl.$on("cartItemRemoved", (e, args) => {
			//$ctrl.totalsQuery.load();
			console.info("Item Removed Refresh");
			$ctrl.refreshShipDates(true);
		});

	}

	selectAll() {
		let $ctrl = this;
		$ctrl.query.results.map((ci) => {
			if (!ci.isKitComponent) ci.selected = true;
		});
		$ctrl.allSelected = true;
		$ctrl.setPositions();
	}
	clearAll() {
		let $ctrl = this;
		$ctrl.query.results.map((ci) => {
			ci.selected = false;
		});
		$ctrl.allSelected = false;
		$ctrl.setPositions();
	}
	canClear() {
		let $ctrl = this;
		return $ctrl.positions.length;
	}

	toggleItem(item) {
		const $ctrl = this;
		if (item.selected) {
			item.selected = false;
		} else {
			item.selected = true;
		}
		$ctrl.setPositions();
	}
	totals() {
		const $ctrl = this;
		return OrderTotalsPrompt({ order: { id: $ctrl.$cart.id } });
	}

	setPositions() {
		let $ctrl = this;
		$ctrl.positions = [];
		$ctrl.query.results.map((ci) => {
			if (ci.selected) $ctrl.positions.push(ci.position);
		});
	}

	refreshTotals() {

	}

	refreshShipDates(reloadQuery) {
		let $ctrl = this;
		if (reloadQuery) {
			$ctrl.query.load();
    }
		$ctrl.query.filters.forEach((g) => g.init && g.init(true));
		$ctrl.query.results.map(s => s.shipOn = moment.utc(s.shipOn).format("MM/DD/YY"));
		$ctrl.query.results.map(s => s.cartItemShipOn = moment.utc(s.cartItemShipOn).format("MM/DD/YY"));
		$ctrl.shipDates = _.groupBy($ctrl.query.results, "shipOn");
		$ctrl.uniqueShipDates = Object.keys($ctrl.shipDates);
		//console.debug("BL*** shipdates = " + JSON.stringify($ctrl.uniqueShipDates));
		$ctrl.uniqueShipDates.sort();
		$ctrl.uniqueShipDates.map((s) => {
			//$ctrl.shipDates[s].total = 0;
			$ctrl.shipDates[s].tabOpen = true;
			//$ctrl.shipDates[s].forEach(function (obj) {
			//	$ctrl.shipDates[s].total += obj.extendedTotal;
			//});
		});

		$ctrl.totalsQuery.load();

		
	}

	openShipDatePrompt() {
		let $ctrl = this;
		return cartItemShipDatePrompt({}).then((cartItem) => {
			let request = {
				cartId: $ctrl.$cart.id,
				shipOn: cartItem.shipOn,
				positions: $ctrl.positions,
			};
			return $ctrl.$cart.bus
				.send("UpdateCartItemShipDate.json", request)
				.then(function (response) {
					if (response.data.exceptions)
						modals.alert(
							"There were line items on your Order that could not be changed based on the Default Availability Date"
						);
					$ctrl.$cart.load().then(function () {
						if ($ctrl.allSelected) {
							$ctrl.query.clearRefinements(true);
							$ctrl.clearAll();
						}
						$ctrl.query.load(true);
						$ctrl.positions.forEach((p) => {
							var item = $ctrl.query.results.filter((r) => r.position === p);
							if (item.length > 0) {
								item[0].shipOn = cartItem.shipOn;
								item[0].$shipOn = item[0].shipOn.format("MM/DD/YY");
								var components = $ctrl.query.results.filter(
									(r) => r.isKitComponent && r.parentPosition === p
								);
								components.forEach((obj) => {
									obj.shipOn = cartItem.shipOn;
									obj.$shipOn = item[0].shipOn.format("MM/DD/YY");
								});
							}
						});
						$ctrl.refreshShipDates();
					});
				});
		});
	}
}
